import React from "react";
import DashboardLayout from "../layout/DashboardLayout";

export default function UCPageShell({ title, children, right }) {
  return (
    <DashboardLayout title={title}>
      <div className="ac-uc-shellhead">
        <div className="ac-uc-shelltitle">{title}</div>
        {right ? <div className="shrink-0">{right}</div> : null}
      </div>

      <div className="mt-5">{children}</div>
    </DashboardLayout>
  );
}